import React from 'react';
import { IQueryResult, IUserDto, IUsersQueryParams } from 'gen/ApiClient';
import { IQueryContext } from 'framework/context/IQueryContext';

export const QueryContext = React.createContext<IQueryContext<IQueryResult<IUserDto>, IUsersQueryParams>>(undefined as any);
